// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from '../../gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import {
  EmployeeFragmentDoc,
  AutofillDataFragmentDoc,
} from '../../common-queries.generated';
import { MinimalInvitationFragmentDoc } from '../../queries.generated';
export type GetEmployeesWithCardsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetEmployeesWithCardsQuery = {
  readonly __typename: 'Query';
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly operationalAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
    } | null;
    readonly employeesWithCards: ReadonlyArray<{
      readonly __typename: 'EmployeeWithCard';
      readonly agent: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly avatarId: Types.AvatarId;
        readonly email: string | null;
        readonly mobileNumber: string | null;
        readonly state: Types.AgentState;
        readonly type: Types.AgentType;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
          readonly legal: string | null;
        };
        readonly latestPromotion: {
          readonly __typename: 'Promotion';
          readonly fid: string;
          readonly state: Types.PromotionState;
          readonly fromType: Types.AgentType | null;
          readonly toType: Types.AgentType;
          readonly initiatedBy: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
            };
          };
        } | null;
        readonly signingJobs: ReadonlyArray<{
          readonly __typename: 'SigningJob';
          readonly type: Types.SigningType;
          readonly url: string | null;
        }>;
        readonly cardAccount: {
          readonly __typename: 'CardAccount';
          readonly accountNumber: string;
          readonly account: {
            readonly __typename: 'Account';
            readonly accountNumber: string;
            readonly balanceNok: {
              readonly __typename: 'AmountInfo';
              readonly asNumber: number;
            } | null;
            readonly autofill: {
              readonly __typename: 'Autofill';
              readonly desiredAmount: string;
              readonly lowLimit: string;
              readonly dailyLimit: string;
              readonly isDailyLimitReached: boolean;
            } | null;
          };
          readonly card: {
            readonly __typename: 'Card';
            readonly fid: string;
            readonly lastFourDigits: string | null;
            readonly state: Types.CardState;
            readonly expirationYear: number;
            readonly expirationMonth: number;
          } | null;
        } | null;
      };
      readonly accounts: ReadonlyArray<{
        readonly __typename: 'Account';
        readonly accountNumber: string;
        readonly name: string;
        readonly state: Types.AccountState;
        readonly balanceNok: {
          readonly __typename: 'AmountInfo';
          readonly asNumber: number;
        } | null;
        readonly autofill: {
          readonly __typename: 'Autofill';
          readonly desiredAmount: string;
          readonly lowLimit: string;
          readonly dailyLimit: string;
          readonly isDailyLimitReached: boolean;
        } | null;
        readonly cards: ReadonlyArray<{
          readonly __typename: 'Card';
          readonly fid: string;
          readonly state: Types.CardState;
          readonly expirationYear: number;
          readonly expirationMonth: number;
        }>;
      }>;
    }>;
    readonly invitations: ReadonlyArray<{
      readonly __typename: 'Invitation';
      readonly fid: string;
      readonly key: string;
      readonly state: Types.InvitationState;
      readonly email: string;
      readonly createdAt: string;
    }>;
  };
};

export type RevokeInvitationMutationVariables = Types.Exact<{
  fid: Types.Scalars['UUID'];
}>;

export type RevokeInvitationMutation = {
  readonly __typename: 'Mutation';
  readonly revokeInvitation: string;
};

export const GetEmployeesWithCardsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEmployeesWithCards' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operationalAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountNumber' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employeesWithCards' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agent' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Employee' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accounts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accountNumber' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'balanceNok' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asNumber' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'autofill' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'desiredAmount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lowLimit' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dailyLimit' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'isDailyLimitReached',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cards' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fid' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'state' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'expirationYear',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'expirationMonth',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invitations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MinimalInvitation' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...EmployeeFragmentDoc.definitions,
    ...AutofillDataFragmentDoc.definitions,
    ...MinimalInvitationFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  GetEmployeesWithCardsQuery,
  GetEmployeesWithCardsQueryVariables
>;
export const RevokeInvitationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RevokeInvitation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revokeInvitation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fid' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RevokeInvitationMutation,
  RevokeInvitationMutationVariables
>;
